import { computed } from '@ember/object';
import { equalToProperty } from '@intercom/pulse/lib/computed-properties';
import MediaUpload from '@intercom/embercom-composer/components/mixins/media-upload';
import { normalizeEvent } from '@intercom/embercom-composer/lib/normalize-event';
import $ from 'jquery';
import { alias, and, empty, not, or } from '@ember/object/computed';
import { bind, schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(MediaUpload, {
  classNames: ['composer-popover-controller'],
  isCurrentlyFocused: true,
  currentEditorHasBeenDismissed: equalToProperty('dismissedEditorObjectId', 'composerState.currentEditableObject.id'),
  currentEditorHasNotBeenDismissed: not('currentEditorHasBeenDismissed'),
  currentEditableObject: alias('composerState.currentEditableObject'),
  hasNoCurrentEditableBlock: empty('composerState.currentEditableBlock'),
  selectionIsInViewport: alias('selectionCoordinates.isWithinViewport'),
  hoveredCoordinatesAreInViewport: alias('hoverCoordinates.isWithinViewport'),
  hoveredCoordinatesAreInLeftPadding: alias('hoverCoordinates.isWithinLeftPadding'),
  hoveredCoordinatesNotInLeftPadding: not('hoveredCoordinatesAreInLeftPadding'),
  hoveredCoordinatesAreInRightPadding: alias('hoverCoordinates.isWithinRightPadding'),
  hoveredCoordinatesNotInRightPadding: not('hoveredCoordinatesAreInRightPadding'),
  currentEditorNotDismissedAndInViewport: and('currentEditorHasNotBeenDismissed', 'selectionIsInViewport'),
  showAnchorEditor: and('isCurrentlyFocused', 'currentEditableObject.isAnchor', 'currentEditorNotDismissedAndInViewport'),
  showImageEditor: and('isCurrentlyFocused', 'currentEditableObject.isImage', 'currentEditorNotDismissedAndInViewport', 'currentEditableObject.hasSuccessfullyUploaded'),
  showVideoFileEditor: and('isCurrentlyFocused', 'currentEditableObject.isVideoFile', 'currentEditorNotDismissedAndInViewport', 'currentEditableObject.hasSuccessfullyUploaded'),
  showButtonEditor: and('isCurrentlyFocused', 'currentEditableObject.isButton', 'currentEditorNotDismissedAndInViewport'),
  showAttributeEditor: and('isCurrentlyFocused', 'currentEditableObject.isAttribute', 'currentEditorNotDismissedAndInViewport'),
  showHtmlEditor: and('isCurrentlyFocused', 'currentEditableObject.isHtml', 'currentEditorNotDismissedAndInViewport'),
  showFacebookLikeButtonEditor: and('isCurrentlyFocused', 'currentEditableObject.isFacebookLikeButton', 'currentEditorNotDismissedAndInViewport'),
  showTwitterFollowButtonEditor: and('isCurrentlyFocused', 'currentEditableObject.isTwitterFollowButton', 'currentEditorNotDismissedAndInViewport'),
  showTextFormatter: and('isCurrentlyFocused', 'uiSelection.isRangeSelection', 'attributeIsNotSelected', 'composerState.selection.doesNotContainsCodeBlock', 'currentEditorNotDismissedAndInViewport', 'hasNoCurrentEditableBlock', 'config.needsTextFormatter'),
  showVideoEditor: and('isCurrentlyFocused', 'currentEditableObject.isVideo', 'currentEditorNotDismissedAndInViewport'),
  attributeIsNotSelected: not('currentEditableObject.isAttribute'),
  currentEditableDasherizedType: Em.computed('currentEditableObject.type', function () {
    let hasEditor = this.get('currentEditableObject.hasEditor');
    if (hasEditor) {
      return Em.String.dasherize(this.get('currentEditableObject.type'));
    } else {
      return 'null'; //rendering 'null-editor-1' to prevent a createChildViews error in dynamic-component (TODO: GJ: create p3 issue)
    }
  }),
  displayedEditorType: computed('currentEditableDasherizedType', function () {
    return `${this.currentEditableDasherizedType}-editor`;
  }),
  isEditorVisible: or('showTextFormatter', 'showAnchorEditor', 'showImageEditor', 'showVideoFileEditor', 'showButtonEditor', 'showAttributeEditor', 'showVideoEditor', 'showFacebookLikeButtonEditor', 'showTwitterFollowButtonEditor', 'showHtmlEditor', 'showImageTextEditor'),
  isEditorNotVisible: not('isEditorVisible'),
  hasNoCurrentEditableObject: not('composerState.hasCurrentEditableObject'),
  isNotTyping: not('isTyping'),
  showMediaAndAttributeInserter: and('hoveredCoordinatesAreInViewport', 'hoveredCoordinatesNotInLeftPadding', 'hoveredCoordinatesNotInRightPadding'),
  showMediaInserterOnly: and('hoveredCoordinatesAreInViewport', 'hoveredCoordinatesAreInLeftPadding', 'hoveredCoordinatesNotInRightPadding'),
  showAttributeInserterOnly: and('hoveredCoordinatesAreInViewport', 'hoveredCoordinatesAreInRightPadding', 'hoveredCoordinatesNotInLeftPadding'),
  showMediaInserterByCoordinates: or('showMediaAndAttributeInserter', 'showMediaInserterOnly'),
  showAttributeInserterByCoordinates: or('showMediaAndAttributeInserter', 'showAttributeInserterOnly'),
  showMediaInserter: and('isEditorNotVisible', 'isNotTyping', 'config.showMediaInserter', 'showMediaInserterByCoordinates'),
  showAttributeInserter: and('isEditorNotVisible', 'isNotTyping', 'config.allowAttribute', 'config.attributeInserter', 'showAttributeInserterByCoordinates', 'currentEditableObjectIsNullOrEditable'),
  showImageTextEditor: and('isCurrentlyFocused', 'currentEditableObject.isImageTextBlock', 'currentEditorNotDismissedAndInViewport'),
  currentEditableObjectIsNullOrEditable: not('currentEditableObject.isNotEditable'),
  resetDismissedEditor: Em.observer({
    dependentKeys: ['currentEditableObject', 'composerState.selection.info'],
    fn() {
      this.set('dismissedEditorObjectId', 'none');
    },
    sync: false
  }),
  bodyClickHandler(e) {
    if (this.isDestroyed) {
      return;
    }
    let isTargetInBody = $('body').find(e.target).length !== 0;
    let thisComposer = $(this.element).closest('.embercom-composer');
    let isTargetOutsideOfThisComposer = !thisComposer.find(e.target).length;
    this.set('isCurrentlyFocused', !isTargetOutsideOfThisComposer);
    let isTargetOutsideOfInserters = !$('.composer-media-inserters').find(e.target).length;
    let isTargetOutsideOfAttributeInserter = !$('.composer-attribute-selector').find(e.target).length;
    if (isTargetOutsideOfInserters && this.get('mediaInserter')) {
      this.get('mediaInserter').send('minimize');
    }
    if (isTargetOutsideOfAttributeInserter && this.get('attributeInserter')) {
      this.get('attributeInserter').send('minimize');
    }
    if (isTargetOutsideOfThisComposer && isTargetInBody && this.get('displayedEditor')) {
      this.get('displayedEditor').send('dismiss');
    }
    if ($(e.target).closest('ic-block, ic-attribute').length !== 0) {
      this.resetDismissedEditor();
    }
  },
  setupBodyClickHandler: Em.on('didInsertElement', function () {
    $('body').on(`mousedown.${this.get('elementId')}`, bind(this, this.bodyClickHandler));
  }),
  removeEventHandlers: Em.on('willDestroyElement', function () {
    $('body').off(`mousedown.${this.get('elementId')}`);
  }),
  change(event) {
    let nativeEvent = normalizeEvent(event);
    if (nativeEvent) {
      let target = nativeEvent.target;
      if ($(target).is('.composer-file-upload')) {
        this.insertMediaFile(target.files[0]);
        if (this.get('uploadType') === 'attachment') {
          this.get('scrollToAttachments')();
        }
      }
    }
  },
  collapseSelectionToRight() {
    let composerState = this.get('composerState');
    let selection = composerState.get('selection');
    this.get('composerState').setSelection(selection.get('endBlockIndex'), selection.get('endItemIndex'), selection.get('endPositionIndex'), selection.get('endBlockIndex'), selection.get('endItemIndex'), selection.get('endPositionIndex'));
    this.get('updateDomAndSelection')();
  },
  actions: {
    hideEditor(editableObjectId) {
      this.set('dismissedEditorObjectId', editableObjectId);
    },
    moveSelectionPastEntityOrBlock() {
      this.get('composerState').moveSelectionPastEntityOrBlock();
      this.get('updateDomAndSelection')();
    },
    openFileDialog(uploadType) {
      this.set('uploadType', uploadType);
      schedule('afterRender', this, this.openFileDialog);
    },
    insertBlock(block, options) {
      this.get('insertBlock')(block, options);
    },
    createBlock(type, data) {
      this.get('createBlock')(type, data);
    },
    insertCharacter(character) {
      let composerState = this.get('composerState');
      composerState.insertCharacters(character);
      composerState.insertCharacter(' ');
      this.get('updateDomAndSelection')();
    },
    insertAttribute(options) {
      this.get('insertAttribute')(options);
    },
    deleteEntity(entityId) {
      try {
        this.get('composerState').deleteEntityById(entityId);
        this.get('updateDomAndSelection')();
      } catch (error) {
        this.get('onError')(error);
      }
    },
    triggerDomUpdate() {
      this.get('updateDomIfNotFocused')();
    },
    applyActionToSelection(actionName, options) {
      if (actionName === 'convertToBlock') {
        try {
          this.get('composerState').convertSelectionToBlock(options.type);
        } catch (error) {
          this.get('onError')();
        }
        this.get('updateDomAndSelection')();
      } else if (actionName === 'anchor') {
        if (!this.get('composerState.formattingOptionStates.anchor.isActive')) {
          this.get('format')(actionName);
        } else {
          this.collapseSelectionToRight();
        }
      } else {
        this.get('format')(actionName);
      }
    },
    align(direction) {
      this.get('composerState').align(direction);
      this.get('updateDomAndSelection')();
    }
  }
});